import { AUTH_TOKEN_TEXT } from "../../Constants";
import { API } from "../../utils/api";
import { removeLocalData, saveLocalData } from "../../utils/LocalStorage";
import {
  loginUser,
  toggleMenu,
  toggleRightSidebar,
  updateUser,
} from "../Reducers/AuthReducers";

export const loginAction = (data, dispatch) =>
  API.login({
    ...data,
    email: data.email
      ? String(data.email).toLowerCase()
      : data.email,
  }).then((res) => {
    if (res.type === "success") {
      saveLocalData(AUTH_TOKEN_TEXT, res.accessToken);
      dispatch(loginUser({ user: res.data, isAuthenticated: true }));
    }
    return res;
  });

export const signupAction = (data) =>
  API.signup({
    ...data,
    email: String(data.email || "").toLowerCase(),
  }).then((res) => res);

export const verifySignupAction = (data, dispatch) =>
  API.verfiyEmail({
    email: String(data.email || "").toLowerCase(),
    otp: data.otp,
  }).then((res) => {
    if (res.type === "success") {
      saveLocalData(AUTH_TOKEN_TEXT, res.accessToken);
      dispatch(loginUser({ user: res.data, isAuthenticated: true }));
    }
    return res;
  });

export const getAuthUserAction = async (dispatch) =>
  API.getAuthUser().then((res) => {
    if (res.type === "success") {
      // storeLocalData(AUTH_TOKEN_TEXT, res.authToken);
      dispatch(loginUser({ user: res.data, isAuthenticated: true }));
    }

    return res;
  });

export const updateProfileAction = (data, dispatch) =>
  API.updateProfile(data).then((res) => {
    if (res.type === "success" && res.data) {
      dispatch(updateUser({ user: res.data }));
    }
    return res;
  });

export const deleteAccountAction = (data, dispatch) =>
  API.deleteAccount(data).then((res) => {
    if (res.type === "success") {
      removeLocalData(AUTH_TOKEN_TEXT);
      dispatch(loginUser({ user: {}, isAuthenticated: false }));
    }
    return res;
  });

export const logoutAction = (dispatch) => {
  removeLocalData(AUTH_TOKEN_TEXT);
  dispatch(loginUser({ user: {}, isAuthenticated: false }));
};

export const toggleMenuAction = (state, dispatch) => {
  dispatch(toggleMenu({ menuState: state }));
};
export const toggleRightSidebarAction = (state, dispatch) => {
  dispatch(toggleRightSidebar({ rightSidebar: state }));
};
